import React from 'react';
import { FilterButton } from '../Button/Button';
import { FilterDropdown, FilterOption } from './FilterDropdown';
import { FilterCategory } from './FilterCategory';
import './FilterBar.css';


export interface FilterBarProps {
  className?: string;
  filters?: Array<{
    id: string;
    label: string;
    options?: FilterOption[];
    active?: boolean;
    onClick: () => void;
  }>;
  categories?: Array<{
    id: string;
    label: string;
    active?: boolean;
    onClick: () => void;
    count?: number;
  }>;
  dropdowns?: Array<{
    id: string;
    type: 'destination' | 'type';
    level?: 'brand' | 'atacama' | 'patagonia' | 'iguazu' | 'mendoza' | 'santa-catarina';
    options: FilterOption[];
    selectedValue?: string;
    onSelect: (value: string) => void;
    variant?: 'default' | 'compact';
  }>;
  level?: 'brand' | 'atacama' | 'patagonia' | 'iguazu' | 'mendoza' | 'santa-catarina';
  layout?: 'horizontal' | 'vertical';
  alignment?: 'left' | 'center' | 'right';
  spacing?: 'compact' | 'normal' | 'relaxed';
}

/**
 * FilterBar Component - Enhanced Figma Implementation
 * Comprehensive filtering system supporting:
 * - Property-specific theming
 * - Multiple filter types (dropdowns, categories, buttons)
 * - Flexible layouts and spacing
 * - Responsive design patterns
 * - Accessibility features
 */
export const FilterBar: React.FC<FilterBarProps> = ({
  className = '',
  filters = [],
  categories = [],
  dropdowns = [],
  level = 'brand',
  layout = 'horizontal',
  alignment = 'center',
  spacing = 'normal'
}) => {
  return (
    <div className={`filter-bar filter-bar--${layout} filter-bar--${alignment} filter-bar--${spacing} filter-bar--${level} ${className}`}>
      <div className="filter-bar__container">
        {/* Render filter dropdowns */}
        {dropdowns.map((dropdown) => (
          <FilterDropdown
            key={dropdown.id}
            type={dropdown.type}
            level={dropdown.level || level}
            options={dropdown.options}
            selectedValue={dropdown.selectedValue}
            onSelect={dropdown.onSelect}
            variant={dropdown.variant}
          />
        ))}
        
        {/* Render filter categories */}
        {categories.map((category) => (
          <FilterCategory
            key={category.id}
            label={category.label}
            active={category.active}
            onClick={category.onClick}
            level={level}
            count={category.count}
          />
        ))}
        
        {/* Render legacy button filters */}
        {filters.map((filter) => (
          <FilterButton
            key={filter.id}
            active={filter.active}
            onClick={filter.onClick}
          >
            {filter.label}
          </FilterButton>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;